import React, {Fragment} from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import {formatGroupLabel} from "./DropdownDataProviders";

const isValid = () =>
{
    return true ;
}

const errorDiv = ( props ) =>
{
    const errmsg = props.errorText != null && props.errorText.length !== 0 ? props.errorText : "Invalid Value" ;

    const className = props.renderErrorDiv === true ? 'input-error-visible' : 'input-error-invisible' ;

    return <div className={className}>{errmsg}</div>
}

const getCurrentText = ( value, data ) =>
{
    const entry = getEntryWithValue(value,data);

    return entry != null ? entry.label : '' ;
}

const getEntryWithValue = ( value, data ) =>
{
    const entry = data.find ( element => element.value == value );

    return entry  ;
}

export const renderDropdownReadOnly = (props, data) =>
{
    let style = {
        borderColor: '#d8e5ed',
        paddingLeft: '14px',
        color: '#428bcd'
    };

    return (
        <Fragment>
            <label htmlFor={props.name}>{props.label}</label>
            <input
                readOnly = 'readonly'
                type = 'text'
                className = 'form-control'
                value = {getCurrentText(props.value, data.items)}
                style = {style}
                id = {props.id}
                name = {props.name} />
        </Fragment>
    )
}

export const renderDropdown = (props, data, options) =>
{
    const onChange = ( a, b ) =>
    {
        props.onChange ( a,b ) ;
    }

    const isSearchable = options === null || options === undefined ? false : options.isSearchable === true ? true : false ;
    const isClearable = options === null || options === undefined ? false : options.isClearable === true ? true : false ;

    return (
        <Fragment>
            <div className={props.defaultClassName}>
                <label htmlFor={props.name}>{props.label}</label>
                <Select
                    onChange={onChange}
                    tabIndex={props.tabIndex}
                    defaultValue={getEntryWithValue(props.value, data.items)}
                    options={data.items}
                    isSearchable={isSearchable}
                    isClearable={isClearable}
                    name={props.name}
                    formatGroupLabel={formatGroupLabel} />
                {props.renderErrorDiv && errorDiv(props)}
            </div>
        </Fragment>

    )
}

export const renderUserInput = (props) =>
{
    const onChange = ( e ) =>
    {
        props.onChange ( e ) ;
    }

    const className = ( props.className === null || props.className === undefined ) ? 'form-control' : props.className ;

    let style = props.style !== null && props.className !== undefined ? props.style : {} ;

    let type = props.isPassword === true ? 'password' : 'text' ;

    if ( props.readonly !== '' && ( props.readonly !== null && props.readonly !== undefined))
    {
        let style = {
            ...props.style,
            borderColor: '#d8e5ed',
            paddingLeft: '14px',
            color: '#428bcd'
        };

        return (
            <Fragment>
                <label htmlFor={props.name}>{props.label}</label>
                <input
                    readOnly = 'readonly'
                    type = 'text'
                    className = 'form-control'
                    value = {props.value}
                    style = {style}
                    id = {props.id}
                    name = {props.name} />
            </Fragment>
        )
    }

    if ( props.renderErrorDiv === true )
    {
        style.borderColor = '#ff0000' ;
    }

    let properties = {
        key: props.id,
        className: className,
        type: type,
        style: style,
        onChange: onChange,
        autoFocus: props.autofocus === true ? 'autofocus' : '',
        id: props.id,
        name: props.name,
        tabIndex: props.tabIndex,
        readOnly: props.readOnly,
        value: props.value,
    } ;

    if ( props.validation !== undefined && props.validation.isDate === true )
    {
        properties.autoComplete= "nope" ;
    }
    else if ( props.autoComplete != null)
    {
        properties.autoComplete= props.autoComplete ;
    }

    return (
        <Fragment>
            <div className={props.defaultClassName}>
                <label htmlFor={props.name}>{props.label}</label>
                <input
                    readOnly = 'readonly'
                    style = {style}
                    {...properties}
                />
                { (props.renderErrorDiv && !props.isValid ) && errorDiv(props)}
            </div>
        </Fragment>

    )
}

export const renderUserInputDate = (props) =>
{
    const onChange = ( name, value ) =>
    {
        props.onChange ( name, value ) ;
    }

    const className = ( props.className === null || props.className === undefined ) ? 'form-control' : props.className ;

    let style = props.style !== null && props.className !== undefined ? props.style : {} ;

    let type = props.isPassword === true ? 'password' : 'text' ;

    if ( props.readonly !== '' && ( props.readonly !== null && props.readonly !== undefined))
    {
        let style = {
            ...props.style,
            borderColor: '#d8e5ed',
            paddingLeft: '14px',
            color: '#428bcd'
        };

        return (
            <Fragment>
                <label htmlFor={props.name}>{props.label}</label>
                <input
                    readOnly = 'readonly'
                    type = 'text'
                    className = 'form-control'
                    value = {props.value}
                    style = {style}
                    id = {props.id}
                    name = {props.name} />
            </Fragment>
        )
    }

    if ( props.displayErrors === true )
    {
        style.borderColor = '#ff0000' ;
    }

    let properties = {
        key: props.id,
        className: className,
        type: type,
        style: style,
        onChange: onChange,
        autoFocus: props.autofocus === true ? 'autofocus' : '',
        id: props.id,
        name: props.name,
        tabIndex: props.tabIndex,
        readOnly: props.readOnly,
    } ;

    if ( props.validation !== undefined && props.validation.isDate === true )
    {
        properties.autoComplete= "nope" ;
    }
    else if ( props.autoComplete != null)
    {
        properties.autoComplete= props.autoComplete ;
    }

    return (
        <Fragment>
            <div className={props.defaultClassName}>
                <label htmlFor={props.name}>{props.label}</label>
                <DatePicker
                    //selected={date}
                    //onSelect={handleDateSelect} //when day is clicked
                    className='form-control'
                    id={props.name}
                    selected={props.value}
                    onChange={(evt) => {
                        onChange ( props.name, evt )
                    }} //only when value has changed
                />
                { (props.renderErrorDiv && !props.isValid ) && errorDiv(props)}
            </div>
        </Fragment>

    )
}

export const renderUserInputTextarea = (props) =>
{
    const onChange = ( e ) =>
    {
        props.onChange ( e ) ;
    }

    const className = ( props.className === null || props.className === undefined ) ? 'form-control' : props.className ;

    let style = props.style !== null && props.className !== undefined ? props.style : {} ;

    let type = props.isPassword === true ? 'password' : 'text' ;

    if ( props.readonly != '' && ( props.readonly !== null && props.readonly !== undefined))
    {
        let style = {
            ...props.style,
            borderColor: '#d8e5ed',
            paddingLeft: '14px',
            color: '#428bcd'
        };

        return (
            <Fragment>
                <label htmlFor={props.name}>{props.label}</label>
                <input
                    readOnly = 'readonly'
                    type = 'text'
                    className = 'form-control'
                    value = {props.value}
                    style = {style}
                    id = {props.id}
                    name = {props.name} />
            </Fragment>
        )
    }

    if ( props.displayErrors === true )
    {
        style.borderColor = '#ff0000' ;
    }

    let properties = {
        key: props.id,
        className: className,
        type: type,
        style: style,
        onChange: onChange,
        autoFocus: props.autofocus === true ? 'autofocus' : '',
        id: props.id,
        name: props.name,
        tabIndex: props.tabIndex,
        readOnly: props.readOnly,
    } ;

    if ( props.validation !== undefined && props.validation.isDate === true )
    {
        properties.autoComplete= "nope" ;
    }
    else if ( props.autoComplete != null)
    {
        properties.autoComplete= props.autoComplete ;
    }

    return (
        <Fragment>
            <div className={props.defaultClassName}>
                <label htmlFor={props.name}>{props.label}</label>
                <textarea
                    readOnly = 'readonly'
                    style = {style}
                    {...properties}
                />
                { (props.renderErrorDiv && !props.isValid ) && errorDiv(props)}
            </div>
        </Fragment>

    )
}

